import component from './ka-GE/component';
import globalHeader from './ka-GE/globalHeader';
import menu from './ka-GE/menu';
import pages from './ka-GE/pages';
import pwa from './ka-GE/pwa';
import settingDrawer from './ka-GE/settingDrawer';
import settings from './ka-GE/settings';

export default {
  'pagination.total.total': 'სულ',
  'pagination.total.range': 'რეინჯი',
  'pagination.total.item': 'რაოდენობა',
  'navBar.lang': 'ენები',
  'layout.user.link.help': 'დახმარება',
  'layout.user.link.privacy': 'კონფიდენციალურობა',
  'layout.user.link.terms': 'წესები',
  'app.preview.down.block': 'ჩამოტვირთეთ ეს გვერდი თქვენს ადგილობრივ პროექტში',
  'app.welcome.link.fetch-blocks': 'მიღეთ ყველა ბლოკი',
  'app.welcome.link.block-list':
    'გაადვილეთ სტანდარტული გვერდების შექმნა `ბლოკის` განვითარების საფუძველზე',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
};
